import * as momentTz from "moment-timezone";
import { FormatCalendarPicker, FormatDateCalendarPicker } from "src/entity/common/unit.constant";
import { RangeDateDto } from "src/entity/flare/flare-volume.entity";
import moment from "moment";

export const convertedDateRanges = (dateRanges: string[]) => {
  const result = dateRanges.map((range) => {
    const [start, end] = range.split(" - ");
    return {
      startDate: momentTz.tz(start, FormatCalendarPicker, "Asia/Bangkok").format(FormatCalendarPicker),
      endDate: momentTz.tz(end, FormatCalendarPicker, "Asia/Bangkok").format(FormatCalendarPicker),
    };
  });

  return result;
};

export const convertedDateRangesWithoutTime = (dateRanges: string[]) => {
  const result = dateRanges.map((range) => {
    const [start, end] = range.split(" - ");
    return {
      startDate: momentTz.tz(start, FormatDateCalendarPicker, "Asia/Bangkok").format(FormatDateCalendarPicker),
      endDate: momentTz.tz(end, FormatDateCalendarPicker, "Asia/Bangkok").format(FormatDateCalendarPicker),
    };
  });

  return result;
};

export const convertedDateRangesFromFormat = (dateRanges: string[], formatDate: string) => {
  const result = dateRanges.map((range) => {
    const [start, end] = range.split(" - ");
    return {
      startDate: momentTz.tz(start, "Asia/Bangkok").format(formatDate),
      endDate: momentTz.tz(end, "Asia/Bangkok").format(formatDate),
    };
  });

  return result;
};

export const covertedRangesDateToString = (rangesDate: RangeDateDto[]): string[] => {
  if (!rangesDate) return [];
  return rangesDate.map((item) => `${item.startDate} - ${item.endDate}`);
};

/** Normalize legacy hour-only datetime (YYYY-MM-DD HH) to minute format (YYYY-MM-DD HH:mm) */
export const normalizeDateTimeToMinute = (dateTime: string): string => {
  if (!dateTime) return dateTime;
  const hourOnlyMatch = /^\d{4}-\d{2}-\d{2} \d{2}$/;
  if (hourOnlyMatch.test(dateTime)) {
    return `${dateTime}:00`;
  }
  return momentTz.tz(dateTime, FormatCalendarPicker, "Asia/Bangkok").isValid()
    ? momentTz.tz(dateTime, FormatCalendarPicker, "Asia/Bangkok").format(FormatCalendarPicker)
    : dateTime;
};

export const covertedRangesDateToMinuteString = (rangesDate: RangeDateDto[]): string[] => {
  if (!rangesDate) return [];
  return rangesDate.map((item) => `${normalizeDateTimeToMinute(item.startDate)} - ${normalizeDateTimeToMinute(item.endDate)}`);
};

export const covertedRangesDateToStrByFormat = (rangesDate: RangeDateDto[], formatDate: string): string[] => {
  if (!rangesDate) return [];
  return rangesDate.map(
    (item) =>
      `${momentTz.tz(item.startDate, "Asia/Bangkok").format(formatDate)} - ${momentTz.tz(item.endDate, "Asia/Bangkok").format(formatDate)}`,
  );
};

export function isCurrentMonthOrMore(dateString: string) {
  const inputDate = moment(dateString, "YYYY-MMM"); // Parse the input date string
  const currentDate = moment(); // Get the current date

  return currentDate.isSameOrBefore(inputDate, "month"); // Check if current date is the same or after in month granularity
}
